import { options_premiumSubOption_PersonalEmail } from 'owa-locstrings/lib/strings/options_premiumsuboption_personalemail.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { DomainOption } from 'owa-domain-option';
import { DomainOptionForSecondaryUser } from 'owa-domain-option';
import { fetchAndValidateDomain } from 'owa-domain-option';
import { getPremiumUser } from 'owa-domain-option';
import { getSubscriberType } from 'owa-domain-option';

import { trace } from 'owa-trace';

let premiumDashboardDomainSubCategory: OptionSubCategory = {
    key: 'personalemail',
    titleStringKey: options_premiumSubOption_PersonalEmail,
    options: [DomainOption, DomainOptionForSecondaryUser],
    onSelected: () => {
        return loadDomainDashBoard();
    },
};

async function loadDomainDashBoard(): Promise<boolean> {
    try {
        fetchAndValidateDomain();
        getSubscriberType();
        getPremiumUser();
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}

export default premiumDashboardDomainSubCategory;
